import React from 'react';
import { breakpoints, css, styled } from 'styles';

export enum ButtonSize {
  Large,
}

export enum ButtonVariant {
  Outline,
}

export const Button = styled.button<{
  size?: ButtonSize;
  variant?: ButtonVariant;
}>`
  background: #333;
  display: inline-flex;
  height: 32px;
  padding: 0 20px;
  color: #fff;
  font-weight: 600;
  border-radius: 16px;
  border: 0;
  line-height: 32px;
  font-size: 1.4rem;
  margin: 15px auto;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: center;

  ${({ size }) =>
    size === ButtonSize.Large &&
    css`
      height: 48px;
      line-height: 48px;
      border-radius: 24px;
      font-size: 1.5rem;
    `}

  ${({ variant }) =>
    variant === ButtonVariant.Outline &&
    css`
      background: none;
      border: 2px solid #fff;
    `}

  @media (max-width: ${breakpoints.sm}) {
    display: flex;
  }

  &:hover {
    background: #fff;
    color: #000;
  }
`;

export const AnchorButton = (props: any = {}) => <Button {...props} as="a" />;
